<template>
  <div class="_info">
    <h1>
      {{ title }}
      <span
        v-if="moduleAnnotation != ''"
        style="color: #a4a9bf"
        class="ts-info iconfont icon-zhu"
        @click="isNotes()"
      ></span>
    </h1>
    <div class="show-box"></div>
    <div class="_child" v-if="Data.tmb.tmbValue || true">
      <h2>肿瘤突变负荷（TMB）</h2>
      <div class="mar-bottom">
        <p>检测结果</p>
        <h3 @click="handleTmbMsi('0')" style="color: #4b84ff">
          {{ Data.tmb.detectionResult }}
        </h3>
      </div>
      <div class="bor-bottom">
        <p>免疫治疗相关意义</p>
        <h3>{{ Data.tmb.detectionMeaningCn }}</h3>
      </div>
    </div>
    <div class="_child" v-if="Data.msi.msiStatus || true">
      <h2>微卫星不稳定性分析（MSI）</h2>
      <div class="mar-bottom">
        <p>检测结果</p>
        <h3 @click="handleTmbMsi('0')" style="color: #4b84ff">
          {{ Data.msi.detectionResult }}
        </h3>
      </div>
      <div class="bor-bottom">
        <p>免疫治疗相关意义</p>
        <h3>{{ Data.msi.detectionMeaningCn }}</h3>
      </div>
    </div>
    <div class="_child" v-if="Data.pdl1.pdl1Flag">
      <h2>免疫组化 PD-L1</h2>
      <p>
        检测结果：<span>{{ Data.pdl1.pdl1Flag }}</span>
      </p>
    </div>
    <div class="btn-text" @click="details()">
      其他免疫治疗相关BIOMARKER<i
        class="iconfont icon-right_medium"
      ></i>
    </div>
    <!-- 注释弹框 -->
    <Notes ref="child" :notesText="notesText" />
  </div>
</template>
<script>
import { myzlData } from "@/api/reportQuery";
import { mapState } from "vuex";
// import Notes from "@/components/notes.vue";
import isiOS from "@/utils/iosAn";
export default {
  props: {
    moduleAnnotation: {
      type: String,
    },
    title: {
      type: String,
    },
    moduleIsShow: {
      type: String,
    },
    templateIsShow: {
      type: String,
    },
    templateId: {
      type: String,
    },
  },
  // components: {
  //   Notes,
  // },
  data() {
    return {
      Data: {
        tmb: {},
        msi: {},
        pdl1: {},
      },
      notesText: {
        h1: this.title,
        p: this.moduleAnnotation,
      },
      tab: [],
    };
  },
  mounted() {
    this.getData();
  },
  computed: {
    ...mapState("embry", ["publicParams"]),
  },
  methods: {
    details() {
      let params = {
        name: "tmbmsi",
        type: "",
        labOriginalSampleNo: this.publicParams.labOriginalSampleNo,
        productId: this.publicParams.productId,
      };
      if (this.$route.query.userAgent == "wxWeb") {
        wx.miniProgram.navigateTo({
          url: "/packageWebView/pages/my-genejiance/my-genejiance",
        });
      } else if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage(params);
      } else {
        window.android.JSCallNative(JSON.stringify(params));
      }
    },
    isNotes() {
      // this.$refs.child.ishow();
      if (this.$route.query.userAgent == "wxWeb") {
        this.$refs.child.ishow();
      } else if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage({
          name: "notes",
          notesText: this.notesText,
          type: "",
        });
      } else {
        window.android.JSCallNative(
          JSON.stringify({
            name: "notes",
            notesText: this.notesText,
            type: "",
          })
        );
      }
    },
    getData() {
      this.$nextTick(async () => {
        try {
          let { data } = await myzlData({
            labOriginalSampleNo: this.publicParams.labOriginalSampleNo,
            productId: this.publicParams.productId,
            moduleId: this.templateId,
          });
          this.Data.tmb = data.tmb;
          this.Data.msi = data.msi;
          this.Data.pdl1 = data.pdl1;
          if (data.tmb.tmbValue) {
            this.tab.push("TMB");
          }
          if (data.msi.msiStatus) {
            this.tab.push("MSI");
          }
          console.log(this.tab, "2222222");
        } catch (error) {}
      });
    },
    handleTmbMsi(type) {
      let params = {
        name: "tmbMsi",
        tabType: type,
        tab: this.tab,
      };
      if (this.$route.query.userAgent == "wxWeb") {
        sessionStorage.setItem("tab", JSON.stringify(this.tab));
        wx.miniProgram.navigateTo({
          url:
            "/packageWebView/pages/tmb-msi/tmb-msi?type=" +
            type +
            "&tab=" +
            JSON.stringify(this.tab),
        });
      } else if (isiOS) {
        window.webkit.messageHandlers.JSCallNative.postMessage(params);
      } else {
        window.android.JSCallNative(JSON.stringify(params));
      }
      // this.$router.push({
      //   name: "tmbMsi",
      //   query: {
      //     type: type,
      //     sessionId: this.$route.query.sessionId,
      //   },
      // });
    },
  },
};
</script>
<style lang="less" scoped>
.show-box {
  height: 20px;
  background: linear-gradient(
    360deg,
    rgba(58, 74, 134, 0) 0%,
    rgba(58, 74, 134, 0.06) 100%
  );
  margin-bottom: 10px;
}
._info {
  padding-bottom: 30px;
  background: @background_color;
  border-radius: 10px;
  margin-top: 20px;
  margin-bottom: 20px;
  ._child {
    padding: 0 24px;
    margin-bottom: 30px;
    .mar-bottom {
      margin-bottom: 20px;
    }
    .bor-bottom {
      border-bottom: 1px solid #e3e5e8;
      padding-bottom: 20px;
    }
    p {
      font-size: 13px;
      font-weight: 400;
      color: #a4a9bf;
      line-height: 28px;
    }
    h3 {
      font-size: 13px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #2f354d;
    }
    h2 {
      font-size: 15px;
      font-weight: 500;
      color: #2f354d;
      line-height: 22px;
      text-indent: 15px;
      position: relative;
      margin-bottom: 12px;
      &::before {
        content: "";
        position: absolute;
        top: 50%;
        left: 0;
        margin-top: -7px;
        width: 3px;
        height: 14px;
        background: #2f354d;
        border-radius: 2px;
      }
    }
  }
  h1 {
    height: 70px;
    font-size: 18px;
    font-weight: 500;
    color: #2f354d;
    line-height: 70px;
    text-indent: 24px;
  }
  .btn-text {
    width: 295px;
    height: 36px;
    padding: 0 16px;
    box-sizing: border-box;
    margin: 0 auto;
    background: #e4ecff;
    border-radius: 6px;
    font-size: 13px;
    font-weight: 400;
    color: #4b84ff;
    line-height: 36px;
    i {
      font-size: 12px;
      float: right;
    }
  }
}
</style>
